/* eslint-disable no-template-curly-in-string */
// inspired by https://github.com/skress/yup-locale-de/blob/master/localeDE.js

export const mixed = {
    default: '${label} ist ungültig',
    required: '${label} darf nicht leer sein.',
};

export const string = {
    matches: 'Bitte überprüfen Sie Ihre Eingabe.',
    email: '${path} muss eine gültige E-Mail-Adresse sein.',
    min: '${label} muss mindestens ${min} Zeichen lang sein.',
    max: '${label} darf höchstens ${max} Zeichen lang sein.',
};

export default {
    mixed,
    string,
};
